import React, { createContext, useState, useEffect } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';
import useEndpoints from '../API/apiConfig';
import axios from 'axios';
export const PosterCategoriesContext = createContext(null);

export const PosterCategoriesProvider = ({ children }) => {
  const [categories, setCategories] = useLocalStorage('categories', [])
  const endpoints = useEndpoints();

  const fetchData = async () => {
    const response = await axios.get(`${endpoints.CATEGORIES}`);
    setCategories(response.data);
  };

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <PosterCategoriesContext.Provider value={{ categories }}>
      {children}
    </PosterCategoriesContext.Provider>
  );
};
